import { snakeCase } from 'lodash-es';
import type { SnakeCasedProperties } from 'type-fest';

const mapKeyToSnakeCase = <T extends Record<string, unknown>>(item: T) =>
  Object.keys(item).reduce((acc, key) => {
    const snakeCasedKey = snakeCase(key);
    acc[snakeCasedKey] = item[key as keyof T];
    return acc;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as any) as SnakeCasedProperties<T>;

export const mapKeysToSnakeCaseDeep = <T extends Record<string, unknown>>(item: T) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const camelCaseData = Object.entries(item).reduce(processDeepValues, {});
  const snakeCaseData = mapKeyToSnakeCase(camelCaseData);
  return snakeCaseData;
};

const processDeepValues = (acc: Record<string, unknown>, [key, value]: [string, unknown]) => {
  if (Array.isArray(value)) {
    acc[key] = value.map((item) => (typeof item === 'object' ? mapKeysToSnakeCaseDeep(item) : item));
  } else if (typeof value === 'object' && value !== null) {
    acc[key] = mapKeysToSnakeCaseDeep(value as Record<string, unknown>);
  } else {
    acc[key] = value;
  }
  return acc;
};

export default mapKeyToSnakeCase;
